import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';
import { NotificationService } from '../../../../Services/notification.service';
import { UsersearchService } from '../../../../Services/User/UserSearch/usersearch.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';

interface StaffDocument {
  doc_user_img?: string;
  [key: string]: any;
}

interface GstStaff {
  id: number;
  name: string;
  mobilenumber: string;
  email: string;
  user_staff_type?: string;
  user_firm_id?: number;
  documents: StaffDocument[];
}

@Component({
  selector: 'app-gst-staff-list',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './gst-staff-list.component.html',
  styleUrl: './gst-staff-list.component.css'
})
export class GstStaffListComponent implements OnInit {

  @Output() addNewStaff = new EventEmitter<void>();
  @Output() editStaff = new EventEmitter<number>();
  @Output() showAccessControl = new EventEmitter<number>();

  gstStaffList: GstStaff[] = [];
  fullStaffList: GstStaff[] = [];
  selectedFirmId: number | null = null;

  constructor(
    private userStaffService: UserStaffService,
    private notificationService: NotificationService,
    private userSearchService: UsersearchService,
    private firmSelectionService: FirmSelectionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const firm = this.firmSelectionService.getselectedFirmName();
    if (firm) {
      this.selectedFirmId = firm.id;
    }

    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      if (firm) {
        this.selectedFirmId = firm.id;
        this.getGstStaff();
      }
    });

    this.userSearchService.searchText$.subscribe(text => {
      this.applySearchFilter(text);
    });

    this.getGstStaff();
  }

  applySearchFilter(searchText: string) {
    if (!searchText) {
      this.gstStaffList = [...this.fullStaffList];
      return;
    }
    const text = searchText.toLowerCase();
    this.gstStaffList = this.fullStaffList.filter(s =>
      s.name.toLowerCase().startsWith(text) ||
      s.mobilenumber.startsWith(text) ||
      s.email.toLowerCase().startsWith(text)
    );
  }

  getGstStaff() {
    this.userStaffService.getUserStaff().subscribe({
      next: (res: any) => {
        let staff: GstStaff[] = res.data || [];
        if (this.selectedFirmId) {
          staff = staff.filter((s: any) => s.user_firm_id == this.selectedFirmId);
        }
        this.fullStaffList = staff;
        this.gstStaffList = [...this.fullStaffList];
      },
      error: (err: any) => {
        console.error('Error fetching GST staff:', err);
      }
    });
  }

  onDelete(id: number) {
    this.userStaffService.deleteUserStaff(id).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess('Staff deleted successfully', 'Success');
        this.getGstStaff();
      },
      error: (err: any) => {
        console.error('Error deleting staff:', err);
        this.notificationService.showError('Failed to delete staff', 'Error');
      }
    });
  }

  onEdit(staffId: number) {
    this.editStaff.emit(staffId);
  }

  onCardClick(staffId: number) {
    this.showAccessControl.emit(staffId);
  }
}
